@if (
  state.node?.nodeType === AssetTreeNodeType.TopicLevel1 ||
  state.node?.nodeType === AssetTreeNodeType.TopicLevel2 ||
  state.node?.nodeType === AssetTreeNodeType.TemporaryDirectory
) {
  <a
    [routerLink]="state.link"
    routerLinkActive="active"
    class="flex h-full"
    [class.parent-is-asset]="!!state.node?.parent?.asset"
    [class.is-last-child]="state.cellRendererParams?.node?.lastChild"
    [class.is-correlated-asset-hovered]="state.correlatedAssetHovered"
    draggable="false"
    [mtxTooltip]="tooltipTmpl"
    [mtxTooltipDisabled]="!state.isTemporaryDirectory"
    (click)="$event.preventDefault()"
  >
    <div class="flex">
      @for (_ of [].constructor(state.nestingLevel); track $index) {
        <span class="node-padding"></span>
      }
    </div>

    <span class="node-content asset-tree-row">
      <span
        class="text truncate"
        [class.temporary]="state.isTemporaryDirectory"
        [matTooltip]="state.node?.uiName ?? ''"
        [matTooltipPosition]="'right'"
      >
        @if (state.uiNameParts.prefix) {
          <span class="text-code mr-2 text-xs font-semibold">{{ state.uiNameParts.prefix }}</span>
        }
        <span class="text-content">{{ state.uiNameParts.name }}</span>
      </span>

      @if (state.node?.nodeType !== AssetTreeNodeType.TopicLevel2) {
        <dojo-icon class="node-content-icon chevron" [icon]="state.expanded ? 'chevron-down' : 'chevron-right'" />
      }
      <!-- @if (state.asset && state.asset.level === 2 && state.badgeType) {
        <exam-asset-tree-badge [badgeType]="state.badgeType" [asset]="state.asset" />
      } -->
      <!--@else if (!state.readonly) {
        <div class="asset-tree-row-icons flex items-center gap-2">
          <dojo-icon-button
            [icon]="'plus'"
            (click)="createAsset()"
            data-test="asset-tree-toolbar-button-refresh"
            [mtxTooltip]="'Create asset'"
            [y42StopPropagation]
          />

          <dojo-icon-button
            [icon]="'folder-plus'"
            (click)="createDirectory()"
            data-test="asset-tree-toolbar-button-create-directory"
            [mtxTooltip]="'Create sub-folder'"
            [y42StopPropagation]
          />
        </div>
      }-->
    </span>
  </a>

  <ng-template #tooltipTmpl>
    <span>Temporary directory</span>
  </ng-template>
} @else if (state.node?.nodeType === AssetTreeNodeType.FavoriteAsset) {
  <a
    [routerLink]="state.link"
    routerLinkActive="active"
    class="align-items flex w-full rounded pl-1 pr-0.5"
    draggable="false"
    (click)="$event.preventDefault()"
  >
    @if (state.asset && state.asset.level === 2 && state.badgeType) {
      <span class="truncate font-normal">
        <dojo-localized-string [content]="state.asset.name" />
      </span>
      <exam-asset-tree-badge
        [badgeType]="state.badgeType"
        [asset]="state.asset"
        class="flex items-center"
        [dojoStopPropagation]
      />
    }
  </a>
} @else if (state.node?.nodeType === AssetTreeNodeType.AssetsContainer) {
  <a
    [routerLink]="state.link"
    routerLinkActive="active"
    class="asset-tree-row flex min-h-[33px] items-center justify-between gap-2 rounded px-2"
    [ngClass]="{
      'cursor-pointer hover:bg-sky-50': !state.readonly
    }"
  >
    <div class="text-primary flex flex-1 items-center text-sm font-normal">
      {{ state.node?.uiName ? (state.node!.uiName | transloco) : '' }}
    </div>
  </a>
} @else if (state.node?.nodeType === AssetTreeNodeType.FavoritesContainer) {
  <div
    class="asset-tree-row flex min-h-[33px] items-center justify-between gap-2 rounded px-2"
    [ngClass]="{
      'cursor-pointer hover:bg-sky-50': !state.readonly
    }"
  >
    <div class="flex items-center justify-between gap-1">
      <div class="text-primary flex items-center text-sm font-normal">
        {{ state.node?.uiName ?? '' }}
      </div>

      <dojo-icon
        class="node-content-icon chevron text-secondary"
        [icon]="state.expanded ? 'chevron-down' : 'chevron-right'"
      />
    </div>

    <!--@if (!state.readonly && state.node?.nodeType === AssetTreeNodeType.AssetsContainer) {
      <div class="asset-tree-row-icons flex items-center gap-2">
        <dojo-icon-button
          [icon]="'plus'"
          (click)="createRootAsset()"
          data-test="asset-tree-toolbar-button-refresh"
          [mtxTooltip]="'Create asset'"
          [y42StopPropagation]
        />

        <dojo-icon-button
          [icon]="'folder-plus'"
          (click)="createRootDirectory()"
          data-test="asset-tree-toolbar-button-create-directory"
          [mtxTooltip]="'Create folder'"
          [y42StopPropagation]
        />
      </div>
    }-->
  </div>
}
